(() => {
  if (window.haiyiWishlistTelemetry) return;
  const node = document.getElementById('hw-config');
  if (!node) return;
  const config = JSON.parse(node.textContent).analytics;
  if (!config || config.designMode || window.Shopify?.designMode) return;
  const names = new Set(['exposed', 'save_success', 'view', 'cart_success', 'error']);
  const categories = new Set(['storage_read', 'storage_write', 'product_load', 'cart_rejected', 'cart_uncertain', 'cart_read', 'cart_display']);
  const once = new Set(), pending = new Set(), queue = [], visible = new Set();
  const observed = new WeakSet();
  let polling, exposureTimer, exposureTarget, viewing = false;
  const prefix = config.environment === 'production' ? 'hw_' : 'hw_test_';
  const allowed = () => {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch { return false; }
  };
  const single = name => name === 'exposed' || name === 'view';
  function resetExposure() {
    clearTimeout(exposureTimer);
    exposureTimer = exposureTarget = null;
  }
  function discard() {
    queue.length = 0;
    pending.clear();
    clearInterval(polling);
    polling = null;
    resetExposure();
  }
  function deliver(item) {
    if (!allowed() || typeof window.clarity !== 'function') return false;
    try {
      window.clarity('set', 'hw_environment', config.environment === 'production' ? 'production' : 'preview');
      window.clarity('set', 'hw_feature', 'wishlist');
      window.clarity('set', 'hw_version', config.version);
      if (item.category) window.clarity('set', 'hw_error_category', item.category);
      window.clarity('event', `${prefix}wishlist_${item.name}`);
      if (single(item.name)) once.add(item.name);
      return true;
    } catch { return false; }
  }
  function flush() {
    if (!allowed()) { discard(); return; }
    while (queue.length) {
      const item = queue[0];
      if (Date.now() - item.time >= 10000) {
        queue.shift(); pending.delete(item.name); continue;
      }
      if (typeof window.clarity !== 'function') break;
      // Consume before calling the SDK: an exception must never cause duplicate delivery.
      queue.shift(); pending.delete(item.name); deliver(item);
    }
    if (!queue.length) { clearInterval(polling); polling = null; }
  }
  function record(name, category) {
    if (!names.has(name) || !allowed()) return;
    if (single(name) && (once.has(name) || pending.has(name))) return;
    const item = {name, category: categories.has(category) ? category : undefined, time: Date.now()};
    if (typeof window.clarity === 'function') { flush(); deliver(item); return; }
    if (queue.length === 20) { const removed = queue.shift(); pending.delete(removed.name); }
    queue.push(item);
    if (single(name)) pending.add(name);
    if (!polling) polling = setInterval(flush, 200);
  }
  function actionable(element) {
    if (!element.isConnected || element.disabled || element.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
    const rect = element.getBoundingClientRect(), style = getComputedStyle(element);
    return rect.width > 0 && rect.height > 0 && style.visibility !== 'hidden' && style.opacity !== '0';
  }
  function exposure() {
    if (once.has('exposed') || pending.has('exposed') || document.visibilityState !== 'visible' || !allowed()) { resetExposure(); return; }
    if (exposureTarget && visible.has(exposureTarget) && actionable(exposureTarget)) return;
    resetExposure();
    exposureTarget = [...visible].find(actionable);
    if (!exposureTarget) return;
    exposureTimer = setTimeout(() => {
      if (visible.has(exposureTarget) && actionable(exposureTarget) && document.visibilityState === 'visible') record('exposed');
      resetExposure();
    }, 1000);
  }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting && entry.intersectionRatio >= 0.5) visible.add(entry.target); else visible.delete(entry.target); });
    exposure();
  }, {threshold: [0, 0.5, 1]});
  function watch() {
    document.querySelectorAll('[data-wishlist-toggle], [data-wishlist-link]').forEach(element => {
      if (!observed.has(element)) { observed.add(element); observer.observe(element); }
    });
    visible.forEach(element => { if (!element.isConnected) { visible.delete(element); observer.unobserve(element); } });
    exposure();
  }
  function consentChanged() {
    if (!allowed()) { discard(); return; }
    flush();
    if (viewing) record('view');
    exposure();
  }
  window.haiyiWishlistTelemetry = {
    record,
    view() { viewing = true; record('view'); },
    watch
  };
  document.addEventListener('visibilitychange', exposure);
  document.addEventListener('visitorConsentCollected', consentChanged);
  window.addEventListener('pageshow', consentChanged);
  window.addEventListener('pagehide', discard);
  new MutationObserver(watch).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'disabled', 'aria-hidden', 'class', 'style']});
  watch();
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    try { window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => { if (!error) consentChanged(); }); }
    catch { /* Collection remains disabled if privacy state cannot be established. */ }
  }
})();
